<template>
<div class="chapter">
<div class="inner_page">
<h2 class="TOC-FBMHD"><strong>Contents</strong></h2>
<h2 class="TOC-CH-T"><strong><a class="hlink" href="#/OEBPS/c01.htm">Composites and Further Special Effects</a></strong></h2>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c02.htm">Dropping in a Sky</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c03.htm">Blending in a Sky</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c04.htm">Producing Sunbeams</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c05.htm">Constructing a Narrative</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c06.htm">Producing Droplets of Water</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c07.htm">Creating a Composite by Making Simple Selections</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c08.htm">Creating a Composite Using Blending Mode</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c09.htm">Creating a Composite Using Refine Edge</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c10.htm">Making Selections Using Channels</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c11.htm">Creating a Composite with Multiple Layers</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c12.htm">Generating a Reflection</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c13.htm">Creating a Shadow on a Hard Surface</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c14.htm">Creating a Shadow on a Soft Surface</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c15.htm">Creating a Rainbow Using the Gradient Tool</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c16.htm">Producing the Illusion of Lightning</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c17.htm">Presenting Images in Sequences</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c18.htm">Making a Constructed Image</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c19.htm">Celebrating Texture using the Blending Mode</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c20.htm">Creating a ‘Joiner’ or ‘still movie’</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c21.htm">Creating a Mirror Image</a></strong></p>
<p class="TOC-AHD"><strong><a class="hlink" href="#/OEBPS/c22.htm">Joining Two Landscapes</a></strong></p>
<h2 class="TOC-FBMHD"><strong><a class="hlink" href="#/OEBPS/c23.htm">LOVED THIS BOOK?</a></strong></h2>
<h2 class="TOC-FBMHD"><strong><a class="hlink" href="#/OEBPS/cop.htm">Copyright</a></strong></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ec77c36c